export default __webpack_public_path__ + "static/media/webcam1.d1d881ec.jfif";